import { IWorkProfile } from './IWorkProfile';
import { WorkWeekEditor } from './_components/WorkWeekEditor';
import { fieldOptionsFactory, IFormSchema } from 'spark-forms';
import { ruleUtil } from '../helpers/ruleUtil';
import { RulesOverview } from './_components/RulesOverview';
import { translate } from '../../Locales/i18n/localizationService';

export const workProfileSchema: IFormSchema<IWorkProfile> = {
    fields: {
        id: fieldOptionsFactory.string({
            displayName: translate.t("Common.Id"),
            disable: item => true,
        }),
        name: fieldOptionsFactory.string({
            displayName: translate.t("Common.Name"),
            hide: item => item.resourceGuid != null,
        }),
        start: fieldOptionsFactory.date({
            displayName: translate.t("WorkProfile.CapacityStart"),
            description: translate.t("WorkProfile.CapacityStartDescription"),
            hide: item => item.resourceGuid != null,
            validation: {
                validationRule: async item => {
                    if (item.start != null || item.resourceGuid != null) {
                        return undefined;
                    }
                    return translate.t("WorkProfile.CapacityStartValidation");
                },
            },
        }),
        end: fieldOptionsFactory.date({
            displayName: translate.t("WorkProfile.CapacityEnd"),
            description: translate.t("WorkProfile.CapacityEndDescription"),
            hide: item => item.resourceGuid != null,
            validation: {
                validationRule: async item => {
                    if (item.end != null || item.resourceGuid != null) {
                        return undefined;
                    }
                    return translate.t("WorkProfile.CapacityEndValidation");
                },
            },
        }),
        weekHours: fieldOptionsFactory.customComponent({
            displayName: translate.t("WorkProfile.WeekHours"),
            config: { component: WorkWeekEditor },
        }),
        rules: fieldOptionsFactory.customComponent({
            displayName: translate.t("WorkProfile.Rules"),
            config: {
                component: RulesOverview,
            },
            validation: {
                validationRule: async item => {
                    if (ruleUtil.rulesOverlap(item.rules).overlap) {
                        return translate.t("WorkProfile.RulesValidation");
                    }
                    return null;
                },
            },
        }),
    },
};
